import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';

//components
import Acknowledgements from  '@/components/elements/acknowledgements/Acknowledgements';

//styling
import "../../css/acknowledgements.scss";



const AcknowledgementPortal = () =>  {

        //checking if acknowledgements is enabled
        const [isAckEnabled, setIsAckEnabled] = useState<boolean>(false);

        function checkEnableAckStatus() {
                if((document.querySelector('#koAcknowledgementsEnabled') as HTMLInputElement).checked) {
                        setIsAckEnabled(true);
                } else {
                        setIsAckEnabled(false);
                }
        }

        useEffect(() => {
                if(document.querySelector('#koAcknowledgementsEnabled')) {
                        checkEnableAckStatus()
                        document.querySelector('#koAcknowledgementsEnabled').addEventListener('change', (e) => setIsAckEnabled((e.target as any).checked))
                }
        },[])
       
        //if acknowledgements is enabled, get the target container.
        let targetContainer = document.getElementById('react-acknowledgement-container');
        if (!targetContainer) {
                //if there is nowhere for the portal, do not display
                return null;

        } else {
                //data stored at the react-acknowledgement-container
                // Extract data attributes
                const isOrgAdmin: boolean = targetContainer.getAttribute('data-isOrgAdmin') === 'True';
                const appId: string = targetContainer.getAttribute('data-appId') as string;
                const contentIsArchived: boolean = targetContainer.getAttribute('data-contentIsArchived') === 'True';

                return ReactDOM.createPortal(
                        <Acknowledgements isAckEnabled={isAckEnabled} isOrgAdmin={isOrgAdmin} appId={appId} contentIsArchived={contentIsArchived}/>,
                        targetContainer
                );
        }
} 

export default AcknowledgementPortal;